
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/specialist/create",
      function () {
        return require("private-next-pages/specialist/create.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/specialist/create"])
      });
    }
  